export default __webpack_public_path__ + "static/media/linkdin.1d473299.svg";